import { inject } from "@vercel/analytics"

export const onClientEntry = () => {
  inject()
}
